import * as R from 'ramda';

import { MediaItem } from '@atom/types/media';
import { Task } from '@atom/types/task';
import { WorkOrderDetailType } from '@atom/types/work';
import { FILES_ENDPOINT } from '@atom/utilities/endpoints';
import { setDisplayDate } from '@atom/utilities/timeUtilities';
import { getWorkOrderStatusType } from '@atom/utilities/workOrderStatusUtilities';

import classes from './scdotPdfReport.module.css';

interface Props {
  workOrder: WorkOrderDetailType;
  task: Task;
  media: MediaItem[];
}

const CoverSection = ({ workOrder, task, media }: Props) => {
  const coverPhoto = R.find(R.propEq(workOrder?.mainPhotoId, 'id'))(media);
  const inspectionDate = R.find(R.propEq('Inspection Date', 'title'))(
    task?.fields,
  );
  const teamLeader = R.find(R.propEq('Team Leader', 'title'))(task?.fields);
  const teamMember = R.find(R.propEq('Team Member', 'title'))(task?.fields);

  return (
    <div className={classes.coverSection}>
      <div className={classes.generalDataSection}>
        <div className={classes.tableWrapper}>
          <table>
            <thead>
              <tr>
                <th>General Data</th>
                <th />
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Work:</td>
                <td>{workOrder?.workTemplateName || '-'}</td>
              </tr>
              <tr>
                <td>Work Status:</td>
                <td>
                  {getWorkOrderStatusType(workOrder?.statusId)?.label || '-'}
                </td>
              </tr>
              <tr>
                <td>Inspection Date:</td>
                <td>{setDisplayDate(inspectionDate?.value)}</td>
              </tr>
              <tr>
                <td>Team Leader:</td>
                <td>{teamLeader?.value || '-'}</td>
              </tr>
              <tr>
                <td>Team Member:</td>
                <td>{teamMember?.value || '-'}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className={classes.coverPhotoSection}>
        <div
          style={{
            backgroundImage: `url('${FILES_ENDPOINT}/${coverPhoto?.fileId}_1440')`,
          }}
          className={classes.mainPhotoContainer}
        />
      </div>
    </div>
  );
};

export default CoverSection;
